export default __webpack_public_path__ + "static/media/sess14Im.572d3f99.png";